/**
 * Hubs UI base paths (kept out of routesConfig on branches that drop hubs from the global route table).
 * Fleet/analytics still use hubs RTK endpoints; any in-app navigation to hubs must use these literals.
 */
export const APP_HUBS_BASE = '/app/hubs';
export const APP_CREATE_HUB_PATH = `${APP_HUBS_BASE}/create-hub`;
